import * as applicationHooks from "@rentiohq/shared-frontend/dist/reduxV2/applications/application.hooks";
import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import {
  Activities,
  Card,
  DisplayText,
  ESpacings,
} from "@rentiohq/web-shared/dist/components";
import { ts } from "services";

interface IProps {
  application: IApplication;
  setTab?: (tab: any) => void;
}

export const ApplicationDetailHistory = (props: IProps) => {
  const { application } = props;

  // Span the history across every re-submission for this candidate + property, so the broker
  // does not lose what happened before the candidacy was last re-submitted.
  const { applicationIds } =
    applicationHooks.getCandidacyApplicationIds(application);

  return (
    <Card
      space={ESpacings.base}
      heading={
        <DisplayText size="extraSmall" space="tight">
          {ts.system("history")}
        </DisplayText>
      }
    >
      <Activities
        identifier={`application-${application.id}`}
        filter={{
          where: {
            applicationId: { inq: applicationIds },
          },
        }}
        hasFetchMore={true}
        isCompact={true}
      />
    </Card>
  );
};
